import React, { useContext, useEffect, useState } from 'react'
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom'
import Login from './Login'
import MainApp from './MainApp'
import { GlobalContext } from './context/GlobalContext'
import useAuth from './hooks/useAuth'
import { getApir, getCinfo } from './lib/haxios'
import Loading from './Loading'
import haxios from './lib/haxios'

function App() {
  const navigate = useNavigate()
  const { setCinfo, setUinfo, setLoginError, isLoading, setApir, setLoading } = useContext(GlobalContext)
  const { isAuthed } = useAuth()

  const handleAuth = async () => {
    const cinfo = await getCinfo()

    if (!cinfo) {
      navigate('/login')
      setLoading(false)
      return
    }

    try {
      const apirUrl = await getApir()
      if (!apirUrl) {
        throw new Error('APIR URL not loaded properly')
      }

      setCinfo(cinfo)
      console.info('cinfo', cinfo)
      const uinfo = await haxios.get(`/salesassist/cplusassist/getByUsername/${cinfo.Username}`)
      setUinfo(uinfo)
      const apir = await getApir()
      setApir(apir)
      console.info('cinfo', cinfo)
      console.info('uinfo', uinfo)
      if (window.location.pathname === '/login') navigate('/')
    } catch (e) {
      setLoginError(e.message)
      navigate('/login')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    console.log('isAuthed', isAuthed)
    if (isAuthed === null) return

    if (isAuthed === false) {
      navigate('/login')
      setLoading(false)
      return
    }

    handleAuth()
  }, [isAuthed])

  useEffect(() => {
    if (isLoading === false) return
    handleAuth()
  }, [isLoading])

  if (isLoading) {
    return <Loading />
  }

  return <MainApp />
}

export default App
